 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		48: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"5a689306","1":"commons","2":"40af83622f3c7f47e0a71dea2ee55e8f6cd59aae","3":"ede0530c6eabc7950fb0b383010b0996688cc995","4":"5638e18dca6dcf1271a95cdc4781306f58dc5e00","5":"691ed07fd28126c165cce3da97b28d8f62bbbf62","6":"c21aeb1629509366fe37baf600a5a817453b8bb0","7":"3a52c104c000ffa401d4e4f54939dce5c08d29eb","8":"33d522f59349c7f457486f10d9b335a899226502","9":"3c6fde0b5778a9e3b48d1772d83991036cbd03c9","10":"88e87231b0acd3bba529e93824bfd7320fdac897","11":"24b456b8e0e18a8fefe2d33809ff82e7fb96b97e","12":"79b4e5bdeec50f5867e6ea29713961e926615b57","13":"0dcdac5d2419759584bc99d69229004426e6d575","14":"3ce26fd2a71bb6f6393829a3e58dc554486cfb14","15":"99bd69c1160bc8f9968b5aeae10addca3c58d0b4","16":"a6aec198d7d9493874f809360a22be5b82b9f410","18":"component---src-pages-404-js","19":"component---src-pages-acquista-report-iic-2020-js","20":"component---src-pages-chi-siamo-js","21":"component---src-pages-contatti-js","22":"component---src-pages-en-info-js","23":"component---src-pages-en-intranet-italia-champions-js","24":"component---src-pages-en-report-iic-2019-js","25":"component---src-pages-en-report-iic-2020-js","26":"component---src-pages-evento-intranet-digital-workspace-js","27":"component---src-pages-evento-js","28":"component---src-pages-fotogallery-js","29":"component---src-pages-grazie-dell-acquisto-js","30":"component---src-pages-grazie-dell-acquisto-report-js","31":"component---src-pages-index-js","32":"component---src-pages-info-js","33":"component---src-pages-intranet-italia-champions-js","34":"component---src-pages-online-downloads-js","35":"component---src-pages-online-js","36":"component---src-pages-premio-iic-2019-js","37":"component---src-pages-privacy-js","38":"component---src-pages-programma-js","39":"component---src-pages-rassegna-stampa-js","40":"component---src-pages-report-iic-2019-js","41":"component---src-pages-report-iic-2020-js","42":"component---src-pages-speaker-js","43":"component---src-templates-attivita-js","44":"component---src-templates-intervento-js","45":"component---src-templates-speaker-js"}[chunkId]||chunkId) + "-" + {"0":"38f9b236ac80f29ed615","1":"cd5ab49f8e25028cd02b","2":"4314f132e878f823d11a","3":"e87ab366cce1259f2eb4","4":"81922f4dc80423765170","5":"f8d41afa5e514a8f3773","6":"ad075dd547b9e4f43bac","7":"371533ba8c8feaaf0f7d","8":"7d6ac88f37619cff7dee","9":"e1cf04b9dafccd06ee55","10":"a74f6466529e0cbb7a3e","11":"a79bcfdf835b754a4adb","12":"c2d405e53bb0365d5571","13":"76480473b7aca7695f38","14":"b703f7dc3095ec4d21f1","15":"41672fa74e82591b09de","16":"c6c6246fe87dc9c913e3","18":"29e9ba255c1fb36e938e","19":"8e384e59b41fc4bb7191","20":"dc757217b25562ccdd4a","21":"0a2b166d30b1687b7c3f","22":"569d9d4e5b53eec3673d","23":"ca404ea463c176c9fd86","24":"0efe70b800f2502a0074","25":"f1b8c9d2121f74398163","26":"9f6a42837b58fefa8525","27":"316de1968d29dae9d98c","28":"5d49c9a7ff657ee9d30c","29":"5eaa0aaec07747b301b4","30":"f634e797ad966f9664ed","31":"a4b799f4941c829bfc12","32":"b01be9e244c647ed2d58","33":"9a6650e1898415bc7b72","34":"deb0cb0be4b39d629528","35":"a80ec3ca45d66e9fee30","36":"cd5e33e55ea18d9908bb","37":"6e5f26d9937896450a75","38":"a7b02cfaf103b48434b9","39":"6331c5a5bc1fd8535229","40":"67999ef7450e6183927b","41":"501956a850710277d8f7","42":"625a97b83672f3d183c8","43":"26a9961976630e345bdd","44":"027a8045e346eca2f0c4","45":"4428037478e3cbe08f67"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/2022/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
